import { dispatch } from '@rematch/core';

const initialState = {
  mainAreaContext: 'ORGANIZATION', // ORG_USER_COMMON, ORGANIZATION and USERS
  bcOps: '',
  addUserContext: '',
}

export default {
  state: initialState,
  reducers: {
    setMainAreaContext(state, payload) {
      return {
        ...state,
        mainAreaContext: payload
      }
    },
    setBcOps(state, payload) {
      return {
        ...state,
        bcOps: payload
      }
    },
    setAddUserContext(state, payload) {
      return {
        ...state,
        addUserContext: payload
      }
    },

    clear() {
      return initialState
    }
  },
  effects: {
    addMainAreaContext(mainAreaContext) {
      dispatch.community.setMainAreaContext(mainAreaContext);
    },
    addBreadCrumbOps(ops) {
      dispatch.community.setBcOps(ops);
    },
    setAddUserContextData(payload) {
      dispatch.community.setAddUserContext(payload);
    },
    clearBreadCrumbsOps() {
      dispatch.community.setBcOps('');
    },

  }
}